module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.84cf469.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/sales/dashboard3/assest/font/notosanskr/notokr-bold.woff
// module id = W/3R
// module chunks = 0